import { render, staticRenderFns } from "./areaRecentSalesDetails.vue?vue&type=template&id=07c158ad"
import script from "./areaRecentSalesDetails.vue?vue&type=script&lang=js"
export * from "./areaRecentSalesDetails.vue?vue&type=script&lang=js"
import style0 from "./areaRecentSalesDetails.vue?vue&type=style&index=0&id=07c158ad&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports